import HeaderStatic from "@/components/HeaderStatic";
import cx from "classnames";
import type { ReactNode } from "react";

export const LayoutPane = (props: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cx(
        "h-full overflow-x-hidden overflow-y-auto flex-1 print:h-auto",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};
LayoutPane.displayName = "LayoutPane";

export function LayoutTextPage({
  children,
  headerSubTitle,
}: {
  children: ReactNode;
  headerSubTitle?: string;
}) {
  return (
    <div className="flex h-screen">
      <HeaderStatic subTitle={headerSubTitle}>
        <div className="flex overflow">
          <LayoutPane className="flex flex-col">
            <div className="pl-8 max-w-[600px] mx-auto my-8">{children}</div>
          </LayoutPane>
        </div>
      </HeaderStatic>
    </div>
  );
}

export const LayoutPanelBorder = () => (
  <div className="w-0.5 bg-[#00000066] absolute inset-y-0 z-[1] right-[-2px] sm:block hidden" />
);
